import { BlankState, MenuOption, TitleForMenuOption } from "../BotAnalyticsDashboard";
import { ButtonColor, ButtonSize, Spinner } from "@swivl-mono/ui";
import { UserDataForType } from "../Helpers/DataHelpers";
import { ButtonWithOptions, Button } from "@swivl-mono/ui";

export const User = ({ userData, userMenu, renderTotalsAndChart, onMenuChange, className }) => {
  let content;
  if (userData && userData.total) {
    if (!userData.total.total) {
      content = <div className="loadingContent ">{BlankState()}</div>;
    } else {
      const data = UserDataForType(userData, userMenu);
      content = renderTotalsAndChart(
        userData.total.total.toLocaleString(),
        userData.total.newUsers,
        userData.total.returningUsers,
        "TOTAL",
        "NEW",
        "RETURNING",
        ["#FF5B02", "#FFA900"],
        userMenu === MenuOption.TimeOfDay,
        data,
      );
    }
  } else {
    content = (
      <div className="loadingContent">
        <Spinner />
      </div>
    );
  }
  return (
    <div className={`chartBox ${className || ''}`}>
      <div className="chartHeader">
        {" "}
        <div className="chartHeaderTitle">
          {" "}
          <span>Chats by </span>
          <ButtonWithOptions
            color={ButtonColor.WHITE}
            size={ButtonSize.SMALL}
            buttonOptions={[
              { title: "Day", name: "Day", onClick: () => onMenuChange("userMenu", "Day") },
              { title: "Time of Day", name: "TimeOfDay", onClick: () => onMenuChange("userMenu", "TimeOfDay") },
              { title: "Day of Week", name: "DayOfWeek", onClick: () => onMenuChange("userMenu", "DayOfWeek") },
            ]}
          >
            {TitleForMenuOption(userMenu)}
          </ButtonWithOptions>
        </div>
        <div className="spacer" />
        <div className="chartKey">
          {" "}
          <div className="chartKeyItem">
            {" "}
            <span className="chartKeyBox" style={{ background: "#FF5B02" }} />
            New
          </div>
          <div className="chartKeyItem">
            {" "}
            <span className="chartKeyBox" style={{ background: "#ffa900" }} />
            Returning
          </div>
        </div>{" "}
      </div>
      <div className="chartContent">{content}</div>
    </div>
  );
}
